import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

const Row = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  margin-bottom: 20px;
`;

export { ButtonContainer, Row };
